"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _sbUtils = require("@simplybenefits/sb-utils");
var _Text = _interopRequireDefault(require("../../components/Text"));
var _Button = _interopRequireDefault(require("../../components/Button"));
var _FormModal = _interopRequireDefault(require("../../components/Modals/FormModal"));
var _TextInput = _interopRequireDefault(require("../../components/TextFields/TextInput"));
var _DateInput = _interopRequireDefault(require("../../components/TextFields/DateInput"));
var _NumberInput = _interopRequireDefault(require("../../components/TextFields/NumberInput"));
var _BubbleSelectBlock = _interopRequireDefault(require("../../components/BubbleSelectBlock"));
var _Loader = _interopRequireDefault(require("../../components/Loader"));
var Theme = _interopRequireWildcard(require("../../theme"));
var Services = _interopRequireWildcard(require("../../services"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
var localizationMaps = _interopRequireWildcard(require("../../localization/maps"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var genderMap = {
  male: 'Male',
  female: 'Female',
  other: 'Other'
};
var coverageTypeMap = {
  solo: 'Solo',
  duo: 'Duo',
  family: 'Family'
};
var CensusForm = /*#__PURE__*/function (_PureComponent) {
  function CensusForm() {
    var _this;
    (0, _classCallCheck2["default"])(this, CensusForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, CensusForm, [].concat(args)), _this.state = {
      firstname: '',
      lastname: '',
      email: '',
      birthdate: '',
      className: '',
      divisionName: '',
      hireDate: '',
      gender: '',
      title: '',
      coverageType: '',
      province: '',
      salary: '',
      hourlyWage: '',
      hoursPerWeek: '',
      language: _i18n["default"].t(_tokens["default"].dropdowns.languages.english),
      payrollID: '',
      isEdit: _this.props.currentEmployee !== null,
      divisions: [],
      earningsType: '',
      showTerminationEffectiveDateDialog: false,
      showEffectiveDateDialog: false,
      effectiveDate: dates.getUTC(null, 'YYYY/MM/DD'),
      waiveEligibilityPeriod: null
    }, _this._validateEffectiveDate = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _effectiveDateError, startOfMonth, effectiveDateUTC, effectiveDateError;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(_this.state.isEdit && !_this.props.isMasterSite)) {
              _context.next = 12;
              break;
            }
            _context.next = 3;
            return Services.validateInput('effectiveDate', _this.state.effectiveDate, _i18n["default"].locale);
          case 3:
            _effectiveDateError = _context.sent;
            startOfMonth = dates.getStartOfMonth();
            effectiveDateUTC = dates.getUTC(_this.state.effectiveDate);
            if (effectiveDateUTC < startOfMonth) {
              _effectiveDateError = _i18n["default"].t(_tokens["default"].labels.employees.backdatedChanges);
            }
            _context.next = 9;
            return _this.setState({
              effectiveDateError: _effectiveDateError
            });
          case 9:
            if (!_effectiveDateError) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("return", false);
          case 11:
            return _context.abrupt("return", true);
          case 12:
            _context.next = 14;
            return Services.validateInput('effectiveDate', _this.state.effectiveDate, _i18n["default"].locale);
          case 14:
            effectiveDateError = _context.sent;
            _context.next = 17;
            return _this.setState({
              effectiveDateError: effectiveDateError
            });
          case 17:
            if (!effectiveDateError) {
              _context.next = 19;
              break;
            }
            return _context.abrupt("return", false);
          case 19:
            return _context.abrupt("return", true);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), _this._validateForm = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var firstnameError, lastnameError, emailError, birthdateError, genderError, coverageTypeError, provinceError, hireDateError, earningsTypeError, titleError, classNameError, divisionNameError, hoursPerWeekError, waiveEligibilityPeriodError, hourlyWageError, salaryError;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Services.validateInput('firstname', _this.state.firstname);
          case 2:
            firstnameError = _context2.sent;
            _context2.next = 5;
            return Services.validateInput('lastname', _this.state.lastname);
          case 5:
            lastnameError = _context2.sent;
            _context2.next = 8;
            return Services.validateInput('email', _this.state.email);
          case 8:
            emailError = _context2.sent;
            _context2.next = 11;
            return Services.validateInput('birthdate', _this.state.birthdate, _i18n["default"].locale);
          case 11:
            birthdateError = _context2.sent;
            _context2.next = 14;
            return Services.validateInput('gender', _this.state.gender);
          case 14:
            genderError = _context2.sent;
            _context2.next = 17;
            return Services.validateInput('coverageType', _this.state.coverageType);
          case 17:
            coverageTypeError = _context2.sent;
            _context2.next = 20;
            return Services.validateInput('province', _this.state.province);
          case 20:
            provinceError = _context2.sent;
            _context2.next = 23;
            return Services.validateInput('hireDate', _this.state.hireDate, _i18n["default"].locale);
          case 23:
            _context2.next = 25;
            return _context2.sent;
          case 25:
            hireDateError = _context2.sent;
            _context2.next = 28;
            return Services.validateInput('earningsType', _this.state.earningsType);
          case 28:
            earningsTypeError = _context2.sent;
            _context2.next = 31;
            return Services.validateInput('title', _this.state.title);
          case 31:
            titleError = _context2.sent;
            _context2.next = 34;
            return Services.validateInput('selectClass', _this.state.className);
          case 34:
            classNameError = _context2.sent;
            _context2.next = 37;
            return Services.validateInput('selectDivision', _this.state.divisionName);
          case 37:
            divisionNameError = _context2.sent;
            _context2.next = 40;
            return Services.validateInput('hoursPerWeek', _this.state.hoursPerWeek);
          case 40:
            hoursPerWeekError = _context2.sent;
            waiveEligibilityPeriodError = _this.props.currentAccountMeta === 1 && _this.state.waiveEligibilityPeriod === null;
            hourlyWageError = null;
            salaryError = null;
            if (!(_this.state.earningsType === 'Hourly')) {
              _context2.next = 50;
              break;
            }
            _context2.next = 47;
            return Services.validateInput('hourlyWage', _this.state.hourlyWage);
          case 47:
            hourlyWageError = _context2.sent;
            _context2.next = 54;
            break;
          case 50:
            if (!(_this.state.earningsType === 'Salary')) {
              _context2.next = 54;
              break;
            }
            _context2.next = 53;
            return Services.validateInput('salary', _this.state.salary);
          case 53:
            salaryError = _context2.sent;
          case 54:
            _context2.next = 56;
            return _this.setState({
              firstnameError: firstnameError,
              lastnameError: lastnameError,
              emailError: emailError,
              birthdateError: birthdateError,
              genderError: genderError,
              coverageTypeError: coverageTypeError,
              provinceError: provinceError,
              classNameError: classNameError,
              divisionNameError: divisionNameError,
              hireDateError: hireDateError,
              titleError: titleError,
              earningsTypeError: earningsTypeError,
              salaryError: salaryError,
              hourlyWageError: hourlyWageError,
              hoursPerWeekError: hoursPerWeekError,
              waiveEligibilityPeriodError: waiveEligibilityPeriodError
            });
          case 56:
            if (!(firstnameError || lastnameError || emailError || birthdateError || genderError || coverageTypeError || provinceError || classNameError || divisionNameError || hireDateError || titleError || earningsTypeError || salaryError || hourlyWageError || hoursPerWeekError || waiveEligibilityPeriodError)) {
              _context2.next = 58;
              break;
            }
            return _context2.abrupt("return", false);
          case 58:
            return _context2.abrupt("return", true);
          case 59:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), _this._saveEmployee = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var isEffectiveDateValid, data, success;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this._validateEffectiveDate();
          case 2:
            isEffectiveDateValid = _context3.sent;
            if (isEffectiveDateValid) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return", false);
          case 5:
            _this._closeEffectiveDateDialog();
            data = {
              firstname: _this.state.firstname.trim(),
              lastname: _this.state.lastname.trim(),
              email: _this.state.email.trim(),
              birthdate: Services.dates.formatOutgoingDate(_this.state.birthdate),
              hireDate: Services.dates.formatOutgoingDate(_this.state.hireDate),
              gender: localizationMaps.toEnglish("genders", _this.state.gender),
              coverageType: localizationMaps.toEnglish("coverageTypes", _this.state.coverageType),
              province: localizationMaps.toEnglish("provinces", _this.state.province),
              earningsType: localizationMaps.toEnglish("earningsTypes", _this.state.earningsType),
              salary: _this.state.salary !== '' ? Number(_this.state.salary) : 0,
              hourlyWage: _this.state.hourlyWage !== '' ? Number(_this.state.hourlyWage) : 0,
              hoursPerWeek: _this.state.hoursPerWeek !== '' ? Number(_this.state.hoursPerWeek) : 0,
              language: localizationMaps.toEnglish("languages", _this.state.language).toLowerCase() === "french" ? "fr" : "en",
              payrollID: _this.state.payrollID === '' ? null : _this.state.payrollID,
              classID: Object.keys(_this.props.classData).find(function (key) {
                return _this.props.classData[key].title === _this.state.className;
              }),
              divisionID: Object.keys(_this.props.divisions).find(function (key) {
                return _this.props.divisions[key].title === _this.state.divisionName;
              }),
              title: _this.state.title,
              waiveEligibilityPeriod: _this.state.waiveEligibilityPeriod || false,
              effectiveDate: dates.getUTC(_this.state.hireDate)
            };
            _context3.next = 9;
            return _this.props.addUser(data, _this.props.accountID);
          case 9:
            success = _context3.sent;
            if (success) {
              _this._clear();
            }
            return _context3.abrupt("return", null);
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })), _this._editUser = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var isEffectiveDateValid, data, success;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _this._validateEffectiveDate();
          case 2:
            isEffectiveDateValid = _context4.sent;
            if (isEffectiveDateValid) {
              _context4.next = 5;
              break;
            }
            return _context4.abrupt("return", false);
          case 5:
            _this._closeEffectiveDateDialog();
            data = {
              firstname: _this.state.firstname.trim(),
              lastname: _this.state.lastname.trim(),
              email: _this.state.email.trim(),
              birthdate: Services.dates.formatOutgoingDate(_this.state.birthdate),
              hireDate: Services.dates.formatOutgoingDate(_this.state.hireDate),
              title: _this.state.title,
              gender: localizationMaps.toEnglish("genders", _this.state.gender),
              province: localizationMaps.toEnglish("provinces", _this.state.province),
              earningsType: localizationMaps.toEnglish("earningsTypes", _this.state.earningsType),
              salary: _this.state.salary !== '' ? Number(_this.state.salary) : 0,
              hourlyWage: _this.state.hourlyWage !== '' ? Number(_this.state.hourlyWage) : 0,
              hoursPerWeek: _this.state.hoursPerWeek !== '' ? Number(_this.state.hoursPerWeek) : 0,
              language: localizationMaps.toEnglish("languages", _this.state.language).toLowerCase() === "french" ? "fr" : "en",
              payrollID: _this.state.payrollID === '' ? null : _this.state.payrollID,
              classID: Object.keys(_this.props.classData).find(function (key) {
                return _this.props.classData[key].title === _this.state.className;
              }),
              divisionID: Object.keys(_this.props.divisions).find(function (key) {
                return _this.props.divisions[key].title === _this.state.divisionName;
              }),
              coverageType: localizationMaps.toEnglish("coverageTypes", _this.state.coverageType),
              effectiveDate: dates.getUTC(_this.state.effectiveDate)
            };
            _context4.next = 9;
            return _this.props.updateUser(data, _this.props.currentEmployee.userID, _this.props.accountID);
          case 9:
            success = _context4.sent;
            if (success) {
              _this._clear();
              if (_this.props.onSave) {
                _this.props.onSave();
              }
            }
            return _context4.abrupt("return", null);
          case 12:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })), _this._showTerminationEffectiveDateDialog = function () {
      // if the account is not yet setup then we don't need to ask for an effective date
      if (Number(_this.props.currentAccountMeta.state) === 0) {
        return _this._terminateMember();
      }
      _this.setState({
        showTerminationEffectiveDateDialog: true
      });
      return null;
    }, _this._hideTerminationEffectiveDateDialog = function () {
      _this.setState({
        showTerminationEffectiveDateDialog: false
      });
    }, _this._clear = function () {
      _this.setState({
        firstname: '',
        firstnameError: false,
        lastname: '',
        lastnameError: false,
        email: '',
        emailError: false,
        birthdate: '',
        birthdateError: false,
        className: '',
        classNameError: false,
        divisionName: '',
        divisionNameError: false,
        hireDate: '',
        hireDateError: false,
        gender: '',
        genderError: false,
        title: '',
        titleError: false,
        coverageType: '',
        coverageTypeError: false,
        province: '',
        provinceError: false,
        earningsType: '',
        earningsTypeError: false,
        salary: '',
        salaryError: false,
        hourlyWage: '',
        hourlyWageError: false,
        hoursPerWeek: '',
        hoursPerWeekError: false,
        divisions: [],
        effectiveDate: dates.getUTC(null, 'YYYY/MM/DD'),
        showTerminationEffectiveDateDialog: false,
        showEffectiveDateDialog: false,
        waiveEligibilityPeriod: null,
        waiveEligibilityPeriodError: false
      });
      _this.props.close();
    }, _this._handleInputChange = function (type, value) {
      _this.setState((0, _defineProperty2["default"])({}, type, value));
    }, _this._terminateMember = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
      var success;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _this._hideTerminationEffectiveDateDialog();
            _context5.next = 3;
            return _this.props.removeUser(_this.props.currentEmployee.userID, _this.props.accountID, dates.getUTC(_this.state.effectiveDate));
          case 3:
            success = _context5.sent;
            if (success) {
              _this._clear();
            }
          case 5:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })), _this._openEffectiveDateDialog = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
      var isFormValid;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _this._validateForm();
          case 2:
            isFormValid = _context6.sent;
            if (isFormValid) {
              _context6.next = 5;
              break;
            }
            return _context6.abrupt("return", null);
          case 5:
            if (!(Number(_this.props.currentAccountMeta.state) === 0 || Number(_this.props.currentAccountMeta.state) === 3)) {
              _context6.next = 9;
              break;
            }
            if (!_this.state.isEdit) {
              _context6.next = 8;
              break;
            }
            return _context6.abrupt("return", _this._editUser());
          case 8:
            return _context6.abrupt("return", _this._saveEmployee());
          case 9:
            if (!_this.state.isEdit) {
              _context6.next = 13;
              break;
            }
            _this.setState({
              showEffectiveDateDialog: true
            });
            _context6.next = 14;
            break;
          case 13:
            return _context6.abrupt("return", _this._saveEmployee());
          case 14:
            return _context6.abrupt("return", null);
          case 15:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    })), _this._closeEffectiveDateDialog = function () {
      _this.setState({
        showEffectiveDateDialog: false
      });
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(CensusForm, _PureComponent);
  return (0, _createClass2["default"])(CensusForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.isEdit) {
        var _this$props$classData, _this$props$divisions;
        var currentEmployee = this.props.currentEmployee;
        var employeeLanguage = currentEmployee.language === "fr" ? _i18n["default"].t(_tokens["default"].dropdowns.languages.french) : _i18n["default"].t(_tokens["default"].dropdowns.languages.english);
        this.setState({
          firstname: currentEmployee.firstname || '',
          lastname: currentEmployee.lastname || '',
          email: currentEmployee.email || '',
          birthdate: Services.dates.formatIncomingDate(currentEmployee.birthdate) || '',
          className: ((_this$props$classData = this.props.classData[currentEmployee.classID]) === null || _this$props$classData === void 0 ? void 0 : _this$props$classData.title) || '',
          divisionName: ((_this$props$divisions = this.props.divisions[currentEmployee.divisionID]) === null || _this$props$divisions === void 0 ? void 0 : _this$props$divisions.title) || '',
          hireDate: Services.dates.formatIncomingDate(currentEmployee.hireDate) || '',
          gender: localizationMaps.fromEnglish("genders", currentEmployee.gender) || '',
          title: currentEmployee.title || '',
          coverageType: localizationMaps.fromEnglish("coverageTypes", currentEmployee.coverageType) || '',
          province: localizationMaps.fromEnglish("provinces", currentEmployee.province) || '',
          earningsType: localizationMaps.fromEnglish("earningsTypes", currentEmployee.earningsType) || '',
          salary: currentEmployee.salary || '',
          hourlyWage: currentEmployee.hourlyWage || '',
          hoursPerWeek: currentEmployee.hoursPerWeek || '',
          language: localizationMaps.fromEnglish("languages", employeeLanguage) || '',
          payrollID: currentEmployee.payrollID || '',
          waiveEligibilityPeriod: currentEmployee.waiveEligibilityPeriod || false
        });
      }
    }

    /**
     * @returns {Promise<boolean>}
     * @private
     */
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
        _this$props$currentEm,
        _this$props$currentEm2;
      var _this$props = this.props,
        classes = _this$props.classes,
        title = _this$props.title,
        whitelabel = _this$props.whitelabel,
        _this$props$disableEd = _this$props.disableEditHireDate,
        disableEditHireDate = _this$props$disableEd === void 0 ? false : _this$props$disableEd;
      var disableHireDate = this.state.isEdit && disableEditHireDate;
      var styles = {
        contentBlock: {
          backgroundColor: Theme.colors.surface,
          boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
          display: 'block',
          margin: 'auto auto 30px auto',
          padding: '30px',
          position: 'relative',
          zIndex: Theme.zIndex.container
        },
        newEmployeeSave: {
          marginLeft: '10px'
        }
      };
      var classData = [];

      // eslint-disable-next-line consistent-return, array-callback-return
      _sbUtils.helpers.sortObjByTitle(this.props.classData).map(function (classID) {
        var data = _this2.props.classData[classID];

        // if its an edit and it's modular only show the non-parent classes
        if (_this2.state.isEdit && data.isModular && (data.parentClassID === null || data.parentClassID === "")) {
          return null;
        }

        // if its a new member we need to show the parent classes for modular flex
        if (!_this2.state.isEdit && data.isModular && data.parentClassID !== null && data.parentClassID !== "") {
          return null;
        }
        classData.push({
          key: classID,
          value: _this2.props.classData[classID].title
        });
      });
      var divisions = _sbUtils.helpers.sortObjByTitle(this.props.divisions).filter(function (divisionID) {
        return _this2.props.divisions[divisionID].access !== 'Read';
      }).map(function (divisionID) {
        return {
          key: divisionID,
          value: _this2.props.divisions[divisionID].title
        };
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.contentBlock
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        display: "block",
        align: "left",
        margin: "20px 0",
        customLinkStyle: {
          lineHeight: '40px'
        }
      }, title), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.firstname),
        value: this.state.firstname,
        onChange: function onChange(e) {
          return _this2._handleInputChange('firstname', e.target.value);
        },
        error: Boolean(this.state.firstnameError),
        helperText: this.state.firstnameError,
        disabled: Boolean(this.state.isEdit && this.props.currentEmployee.cert),
        fullWidth: true,
        required: true,
        autoFocus: !this.state.isEdit
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.lastname),
        value: this.state.lastname,
        onChange: function onChange(e) {
          return _this2._handleInputChange('lastname', e.target.value);
        },
        error: Boolean(this.state.lastnameError),
        helperText: this.state.lastnameError,
        disabled: Boolean(this.state.isEdit && this.props.currentEmployee.cert),
        fullWidth: true,
        required: true
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.email),
        value: this.state.email,
        onChange: function onChange(e) {
          return _this2._handleInputChange('email', e.target.value);
        },
        error: Boolean(this.state.emailError),
        helperText: this.state.emailError,
        disabled: Boolean(this.state.isEdit && this.props.currentEmployee.cert),
        fullWidth: true,
        required: true
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.account.dateOfBirthYYYYMMDD),
        value: this.state.birthdate,
        onChange: function onChange(e) {
          return _this2._handleInputChange('birthdate', e.target.value);
        },
        error: Boolean(this.state.birthdateError),
        helperText: this.state.birthdateError,
        disabled: Boolean(this.state.isEdit && this.props.currentEmployee.cert),
        fullWidth: true,
        required: true
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.employees["class"]),
        value: this.state.className,
        onChange: function onChange(e) {
          return _this2._handleInputChange('className', e.target.value);
        },
        error: Boolean(this.state.classNameError),
        helperText: this.state.classNameError,
        fullWidth: true,
        required: true,
        select: true,
        selectOptions: [].concat(classData),
        disabled: !this.props.isMasterSite && Boolean(this.state.isEdit && this.props.currentEmployee.parentClassID !== null) /* if the member has a parentClassID then it's a mod flex account and you cannot change the class  */
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.employees.division),
        value: this.state.divisionName,
        onChange: function onChange(e) {
          return _this2._handleInputChange('divisionName', e.target.value);
        },
        error: Boolean(this.state.divisionNameError),
        helperText: this.state.divisionNameError,
        fullWidth: true,
        required: true,
        select: true,
        selectOptions: (0, _toConsumableArray2["default"])(divisions)
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.employees.hireDate),
        value: this.state.hireDate,
        onChange: function onChange(e) {
          return _this2._handleInputChange('hireDate', e.target.value);
        },
        error: Boolean(this.state.hireDateError),
        helperText: this.state.hireDateError,
        fullWidth: true,
        required: true,
        disabled: disableHireDate
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.gender),
        value: this.state.gender,
        onChange: function onChange(e) {
          return _this2._handleInputChange('gender', e.target.value);
        },
        error: Boolean(this.state.genderError),
        helperText: this.state.genderError,
        fullWidth: true,
        required: true,
        select: true,
        selectOptions: Services.selectFieldOptions.genderOptions()
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.employees.occupation),
        value: this.state.title,
        onChange: function onChange(e) {
          return _this2._handleInputChange('title', e.target.value);
        },
        error: Boolean(this.state.titleError),
        helperText: this.state.titleError,
        fullWidth: true,
        required: true
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.employees.individualDependents),
        value: this.state.coverageType,
        onChange: function onChange(e) {
          return _this2._handleInputChange('coverageType', e.target.value);
        },
        error: Boolean(this.state.coverageTypeError),
        helperText: this.state.coverageTypeError,
        fullWidth: true,
        required: true,
        select: true,
        disabled: Boolean(this.state.isEdit && this.props.currentEmployee.cert),
        selectOptions: Services.selectFieldOptions.coverageOptions()
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.employees.provinceOfResidence),
        value: this.state.province,
        onChange: function onChange(e) {
          return _this2._handleInputChange('province', e.target.value);
        },
        error: Boolean(this.state.provinceError),
        helperText: this.state.provinceError,
        fullWidth: true,
        required: true,
        select: true,
        selectOptions: Services.selectFieldOptions.provinceOptions()
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.employees.earningsType),
        value: this.state.earningsType,
        onChange: function onChange(e) {
          return _this2._handleInputChange('earningsType', e.target.value);
        },
        error: Boolean(this.state.earningsTypeError),
        helperText: this.state.earningsTypeError,
        fullWidth: true,
        required: true,
        select: true,
        selectOptions: Services.selectFieldOptions.earningsTypeOptions()
      })), localizationMaps.toEnglish("earningsTypes", this.state.earningsType) === 'Hourly' ? /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.employees.hourlyRate),
        prefix: "$ ",
        value: this.state.hourlyWage,
        onChange: function onChange(e) {
          return _this2._handleInputChange('hourlyWage', e.target.value);
        },
        error: Boolean(this.state.hourlyWageError),
        helperText: this.state.hourlyWageError,
        fullWidth: true,
        required: true
      })) : /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.employees.salary),
        prefix: "$ ",
        value: this.state.salary,
        onChange: function onChange(e) {
          return _this2._handleInputChange('salary', e.target.value);
        },
        error: Boolean(this.state.salaryError),
        helperText: this.state.salaryError,
        fullWidth: true,
        required: true
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.employees.hoursPerWeek),
        value: this.state.hoursPerWeek,
        onChange: function onChange(e) {
          return _this2._handleInputChange('hoursPerWeek', e.target.value);
        },
        error: Boolean(this.state.hoursPerWeekError),
        helperText: this.state.hoursPerWeekError,
        fullWidth: true,
        required: true
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.employees.employeeLanguage),
        value: this.state.language,
        onChange: function onChange(e) {
          return _this2._handleInputChange('language', e.target.value);
        },
        fullWidth: true,
        required: true,
        select: true,
        selectOptions: Services.selectFieldOptions.languageOptions()
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.employees.payrollID),
        value: this.state.payrollID,
        onChange: function onChange(e) {
          return _this2._handleInputChange('payrollID', e.target.value);
        },
        fullWidth: true
      })),
      // we only allow this when the account is live, if it's pending or in revisions then it's census additions and should be waived automatically by the backend systems
      this.props.currentAccountMeta.status === 1 && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 12,
        md: 6
      }, !this.state.isEdit ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true,
        display: "block",
        align: "left",
        margin: "8px 0 4px"
      }, _i18n["default"].t(_tokens["default"].labels.employees.youMustChooseToWaive)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        display: "block",
        align: "left",
        margin: "4px 0 8px"
      }, _i18n["default"].t(_tokens["default"].labels.employees.waivingMeansThat))) : /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        display: "block",
        align: "left",
        margin: "8px 0 4px"
      }, this.state.waiveEligibilityPeriod ? _i18n["default"].t(_tokens["default"].labels.employees.waitingPeriodWaived) : _i18n["default"].t(_tokens["default"].labels.employees.waitingPeriodNotWaived)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        customStyle: {
          marginTop: "8px",
          marginLeft: "8px"
        },
        allowToggleOff: true,
        first: {
          title: _i18n["default"].t(_tokens["default"].buttons.doNotWaive),
          selected: this.state.waiveEligibilityPeriod === false,
          field: 'doNotWaive',
          customStyle: {
            fontSize: 12
          }
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].buttons.waive),
          selected: this.state.waiveEligibilityPeriod === true,
          field: 'waive',
          customStyle: {
            fontSize: 12
          }
        },
        handleChange: function handleChange(field) {
          if (!_this2.state.isEdit) {
            if (field === 'doNotWaive') {
              _this2._handleInputChange('waiveEligibilityPeriod', false);
            } else if (field === 'waive') {
              _this2._handleInputChange('waiveEligibilityPeriod', true);
            }
          }
        }
      })), this.state.waiveEligibilityPeriodError && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        display: "block",
        align: "left",
        margin: "4px 0",
        color: "red"
      }, _i18n["default"].t(_tokens["default"].labels.employees.chooseToWaiveError))))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        style: {
          marginTop: 20
        }
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: this._clear,
        transparent: true
      }, _i18n["default"].t(_tokens["default"].buttons.cancel)), this.state.isEdit && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        transparent: true,
        onClick: this._showTerminationEffectiveDateDialog
      }, _i18n["default"].t(_tokens["default"].buttons.terminate)), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        customStyle: styles.newEmployeeSave,
        onClick: this._openEffectiveDateDialog,
        color: "primary"
      }, _i18n["default"].t(_tokens["default"].buttons.save))), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showTerminationEffectiveDateDialog,
        close: this._hideTerminationEffectiveDateDialog,
        title: _i18n["default"].t(_tokens["default"].titles.setEffectiveDate),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: this._terminateMember,
        saveButtonText: _i18n["default"].t(_tokens["default"].buttons.terminate),
        customContainerStyle: {
          maxWidth: "500px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, _i18n["default"].t(_tokens["default"].labels.employees.effectiveDateOfTermination)), /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.effectiveDate),
        value: this.state.effectiveDate,
        onChange: function onChange(e) {
          return _this2._handleInputChange('effectiveDate', e.target.value);
        },
        error: Boolean(this.state.effectiveDateError),
        helperText: this.state.effectiveDateError,
        fullWidth: true,
        required: true
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.employees.byClickingThe), " ", /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        customStyle: {
          display: 'inline'
        },
        medium: true,
        bold: true
      }, _i18n["default"].t(_tokens["default"].labels.employees.terminate)), " button below, the termination for ", /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        customStyle: {
          display: 'inline'
        },
        medium: true,
        bold: true
      }, "".concat((_this$props$currentEm = this.props.currentEmployee) === null || _this$props$currentEm === void 0 ? void 0 : _this$props$currentEm.firstname, " ").concat((_this$props$currentEm2 = this.props.currentEmployee) === null || _this$props$currentEm2 === void 0 ? void 0 : _this$props$currentEm2.lastname)), " ", _i18n["default"].t(_tokens["default"].labels.employees.willBeAppliedOnEffectiveDate))), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showEffectiveDateDialog,
        close: this._closeEffectiveDateDialog,
        title: _i18n["default"].t(_tokens["default"].titles.setEffectiveDate),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: this.state.isEdit ? this._editUser : this._saveEmployee,
        saveButtonText: "Submit",
        customContainerStyle: {
          width: 500
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, _i18n["default"].t(_tokens["default"].labels.pleaseProvideEffectiveDate)), /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.effectiveDate),
        value: this.state.effectiveDate,
        onChange: function onChange(e) {
          return _this2._handleInputChange('effectiveDate', e.target.value);
        },
        error: Boolean(this.state.effectiveDateError),
        helperText: this.state.effectiveDateError,
        fullWidth: true,
        required: true
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.changesAppliedOnEffectiveDate))), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: whitelabel,
        noGif: true
      }), /*#__PURE__*/_react["default"].createElement("span", {
        id: "census-form"
      }));
    }
  }]);
}(_react.PureComponent);
var _default = exports["default"] = CensusForm;